<div class="pt-2">
  <div class="flex flex-wrap">
    <div class="flex-grow-1 flex align-items-center">
      <ng-container *ngIf="showRegSearchLink; else plainReg">
        <div
          class="reg-search-pill"
          (click)="onSearchByReg($event)"
          pTooltip="Search routes with this registration"
          tooltipPosition="top"
        >
          <span class="reg-search-pill__reg">{{ task.vehicle.registrationNumber }}</span>
          <span class="reg-search-pill__icon" (click)="onSearchByReg($event)">
            <i class="fa fa-link" aria-hidden="true"></i>
          </span>
        </div>
      </ng-container>
      <ng-template #plainReg>
        <div class="time-vrm-line">{{ task.vehicle.registrationNumber }}</div>
      </ng-template>
    </div>
    <div class="flex-shrink-1">
      <span *ngIf="task.vehicle.isElectric" class="tag bolt"><i class="fa fa-bolt"></i> EV</span>
      <span class="tag" style="margin-right: 0px; font-weight: 500; margin-right: 10px">{{
        task.taskTypeName
      }}</span>
    </div>
  </div>
  <div class="flex flex-wrap">
    <div class="flex-grow-1">
      <div class="make-model" title="{{ task.vehicle?.make }} {{ task.vehicle?.model }}">
        {{ task.vehicle?.make }} {{ task.vehicle?.model }}
      </div>
    </div>
  </div>
</div>
